import { LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { DatePipe, registerLocaleData } from '@angular/common'
import localNl from '@angular/common/locales/nl'
import localFr from '@angular/common/locales/fr'
import localDe from '@angular/common/locales/de'
import localEn from '@angular/common/locales/en'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { SettingsModule } from './core/settings/settings.module'
import { AgreementModule } from './features/agreement/agreement.module'
import { BookingModule } from './features/booking/booking.module'
import { CartModule } from './features/cart/cart.module'
import { ConfigurationOptionModule } from './features/configuration-option/configuration-option.module'
import { LocationModule } from './features/location/location.module'
import { OperationModule } from './features/operation/operation.module'
import { SiteModule } from './features/site/site.module'
import { TagModule } from './features/tag/tag.module'
import { TranslationModule } from './features/translation/translation.module'
import { LayoutModule } from './layout/layout.module'
import { MenuModule } from './menu/menu.module'
import { SharedModule } from './shared/shared.module'
import { OrganizationModule } from './features/organization/organization.module'
import { MemberModule } from './features/member/member.module'
import { UserRoleModule } from './features/role/user-role/user-role.module'
import { MyWorkModule } from './features/my-work/my-work.module'
import { DataTableModule } from '@pascalhonegger/ng-datatable'
import { RoleModule } from './features/role/role.module'
import { RaffleModule } from './features/raffle/raffle.module'
import { RaffleLotModule } from './features/raffle/raffle-lot/raffle-lot.module'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { VisitModule } from './features/visit/visit.module'
import { RolePermissionModule } from './features/role/role-permission/role-permission.module'
import { SerieProposalModule } from './features/serie-proposal/serie-proposal.module'
import { SerieProposalItemModule } from './features/serie-proposal/serie-proposal-item/serie-proposal-item.module'
import { environment } from 'src/environments/environment'
import { FireBaseModule } from './shared/modules/firebase.module'
import { EmptyModule } from './shared/modules/empty.module'
import { ActivityModule } from './features/activity/activity.module'
import { StoredPayMethodModule } from './features/stored-pay-method/stored-pay-method.module'
import { GateModule } from './features/gate/gate.module'
import { DocumentTemplateModule } from './features/document-template/document-template.module'
import { RentalModule } from './features/rental/rental.module'
import { SubscriptionLinkedSubscriptionsModule } from './features/subscription-linked-subscriptions/subscription-linked-subscriptions.module'
import { MetaOptionModule } from './features/meta-option/meta-option.module'
import { MessageModule } from './features/message/message.module'
import { EmailTaskModule } from './features/email-task/email-task.module'
import { EmailTemplateModule } from './features/email-template/email-template.module'
import { DeviceModule } from './features/device/device.module'
import { CompetitionModule } from './features/competition/competition.module'
import { FamilyMemberModule } from './features/family/family-members/family-member.module'
import {
  provideTanStackQuery,
  QueryClient
} from '@tanstack/angular-query-experimental'

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__?: QueryClient
  }
}

registerLocaleData(localEn)
registerLocaleData(localNl)
registerLocaleData(localFr)
registerLocaleData(localDe)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000
    }
  }
})

if (!environment.production && typeof window !== 'undefined') {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    DataTableModule,
    LayoutModule,
    MenuModule,
    SettingsModule,
    SharedModule,
    AppRoutingModule, // must be before other modules with routes
    ConfigurationOptionModule,
    MemberModule,
    RoleModule,
    UserRoleModule,
    RolePermissionModule,
    OrganizationModule,
    CartModule,
    TagModule,
    SiteModule,
    OperationModule,
    AgreementModule,
    BookingModule,
    LocationModule,
    TranslationModule,
    MyWorkModule,
    RaffleModule,
    RaffleLotModule,
    FormsModule,
    BrowserAnimationsModule,
    VisitModule,
    SerieProposalModule,
    SerieProposalItemModule,
    ActivityModule,
    StoredPayMethodModule,
    GateModule,
    DocumentTemplateModule,
    environment.firebaseConfig ? FireBaseModule : EmptyModule,
    RentalModule,
    SubscriptionLinkedSubscriptionsModule,
    MetaOptionModule,
    MessageModule,
    EmailTaskModule,
    EmailTemplateModule,
    DeviceModule,
    CompetitionModule,
    FamilyMemberModule
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'en_US' },
    provideTanStackQuery(queryClient)
  ]
})
export class AppModule {}
